import React, { useState } from "react";
import { Modal, Form } from "react-bootstrap";
import CommonButton from "../commonButton";
import withModal from "../withModal";
import InputField from "../form/InputField";

const RejectModalInner = ({
    onClose,
    onReject,
    reasonLabel = "Reason for rejection",
    placeholder = "Enter reason...",
    rejectText = "Reject",
    cancelText = "Cancel"
}) => {
    const [reason, setReason] = useState("");

    const handleReject = () => {
        if (reason.trim()) {
            onReject(reason);
            setReason("");
        }
    };

    const handleHide = () => {
        setReason("");
        onClose();
    };

    return (
        <Form onSubmit={(e) => e.preventDefault()}>
            <Modal.Body>
                <InputField
                    label={{ name: reasonLabel, class: "sub-text mb-2" }}
                    input={{
                        as: "textarea",
                        rows: 4,
                        placeholder: placeholder,
                        value: reason,
                        onChange: (e) => setReason(e.target.value),
                    }}
                />
            </Modal.Body>
            <Modal.Footer>
                <CommonButton
                    type="button"
                    title={cancelText}
                    variant="outline-secondary"
                    onClick={handleHide}
                />
                <CommonButton
                    type="button"
                    title={rejectText}
                    variant="danger"
                    onClick={handleReject}
                    disabled={!reason.trim()}
                />
            </Modal.Footer>
        </Form>
    );
};

const RejectModal = withModal(RejectModalInner);

export default RejectModal;
